
export default {
  name: 'VsList',
  inheritAttrs: false,
  props: {
    items: {
      type: Array,
      default: null
    },
    primaryKey: {
      type: String,
      default: null
    },
    itemHeight: {
      type: Number,
      default: 200
    },
    animation: {
      type: String,
      default: 'fade'
    },
    lazy: {
      type: Boolean,
      default: false
    },
    ratio: {
      type: Number,
      default: 0.5
    },
    threshold: {
      type: Array,
      default: () => [0, 0.25, 0.5, 0.75, 1]
    },
    duration: {
      type: String,
      default: 'faster'
    },
    loading: {
      type: Boolean,
      default: false
    },
    loadingItems: {
      type: Number,
      default: 4
    }
  },
  computed: {
    hasItems() {
      return this.items && this.items.length
    }
  },
  methods: {
    createObserver() {
      if (!this.lazy) return

      this.observer = new IntersectionObserver(entries => {
        const visible = entries.filter(item => item.intersectionRatio >= this.ratio)

        visible.forEach((entry) => {
          this.$nextTick(() => {
            entry.target.showListItem()
          })
        })

      }, { threshold: this.threshold })
    },
    onInsert(item) {
      if (!this.lazy) return

      item.$el.style.minHeight = `${this.itemHeight}px`
      item.$el.showListItem = () => { item.visible = true }

      this.observer.observe(item.$el)
    },
    onLoad(item) {
      if (!this.lazy) return
      item.$el.style.minHeight = '0px'
    },
    onRemove(item) {
      if (!this.lazy) return
      this.observer.unobserve(item.$el)
    }
  },
  beforeMount() {
    this.createObserver()
  },
  beforeDestroy() {
    if (!this.lazy) return
    this.observer.disconnect()
  }
}
